export function addNotificationRequestUrl(state, payload) {
  state.notificationRequestUrls.push(payload);
}

export function clearNotificationRequestUrl(state, payload) {
  state.notificationRequestUrls = state.notificationRequestUrls.filter((url) => url !== payload);
}
